import {UserType} from '../../user/user-type';

import {ReviewRealtimeHelpLinkConfigType} from './review-realtime-presence-config';

function isReviewRealtimeAllowedBrand(brandId: number, config: ReviewRealtimeHelpLinkConfigType): boolean {
    if (config.available) {
        return true;
    }

    return config.brandIds.includes(brandId);
}

export function canSendReviewRealtime(
    user: UserType | null,
    brandId: number,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    if (user.isStaff && !config.staffCanSend) {
        return false;
    }

    return isReviewRealtimeAllowedBrand(brandId, config);
}

export function canReceiveReviewRealtime(
    user: UserType | null,
    brandId: number,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    return isReviewRealtimeAllowedBrand(brandId, config);
}

export function hasAnyReviewRealtimeReceiveBrand(
    user: UserType | null,
    config: ReviewRealtimeHelpLinkConfigType | null
): boolean {
    if (!user || !config) {
        return false;
    }

    if (config.available) {
        return true;
    }

    return config.brandIds.length > 0;
}
